import { SelectItem } from 'primeng/api';
import { DeltaCalculationMethod } from '../enums/delta-calculation-method';
import { DeltaComparisonMethod } from '../enums/delta-comparison-method';
import { DeltaBoolean } from '../enums/DeltaBoolean';
import { DeltaAgeType } from '../enums/DeltaAgeType';
import { DeltaPatientType } from '../enums';

export class DeltaCalculationMethodLookup {
    static getLookup(): SelectItem[] {
        return [
            { label: 'Absolute Difference', value: DeltaCalculationMethod.AbsoluteDifference },
            { label: 'Percent Change', value: DeltaCalculationMethod.PercentChange },
        ];
    }
}

export class DeltaComparisonMethodLookup {
    static getLookup(): SelectItem[] {
        return [
            { label: 'Last Result', value: DeltaComparisonMethod.LastResult },
            { label: 'Average Last N Results', value: DeltaComparisonMethod.AverageLastNResults },
        ];
    }
}

export class DeltaBooleanLookup {
    static getLookup(): SelectItem[] {
        return [
            { label: 'No', value: DeltaBoolean.No },
            { label: 'Yes', value: DeltaBoolean.Yes },
        ];
    }
}

export class DeltaAgeTypeLookup {
    static getLookup(): SelectItem[] {
        return [
            { label: 'Days', value: DeltaAgeType.Days },
            { label: 'Months', value: DeltaAgeType.Months },
            { label: 'Years', value: DeltaAgeType.Years },
        ];
    }
}

export class DeltaPatientTypeLookup {
    static getLookup(): SelectItem[] {
        return [
            { label: 'OPD', value: DeltaPatientType.OPD },
            { label: 'IPD', value: DeltaPatientType.IPD },
            { label: 'ER', value: DeltaPatientType.ER },
            { label: 'ICU', value: DeltaPatientType.ICU },
        ];
    }
}